import vueComponentOptions from 'components/InputTextHtml.vue';

const TextHtmlInput = Vue.extend(vueComponentOptions);

module.exports = TextHtmlInput;